"use client";

import Image from "next/image";
import Typography from "../new/Common/Typography";
import SectionSkinBackground from "../new/HomePage/SectionSkinBackground";
import useViewType from "@/utils/Hooks/useViewType";
import { useState } from "react";
const SectionNSDC = () => {
  const isMobile = useViewType(992);
  const [viewAll, setViewAll] = useState(false);
  return <SectionSkinBackground data-sentry-element="SectionSkinBackground" data-sentry-component="SectionNSDC" data-sentry-source-file="SectionNSDC.tsx">
      <div className="faq-container">
        <p className="pre-header">Government Certified</p>
        <h2 className="section-header">Earn NSDC Certification</h2>
        {isMobile && <CertImage isMobile={isMobile} />}
        <div className={`para flex flex-col ${isMobile && (viewAll ? "" : "section-subheading-mask")}`}>
          <Typography variant="Body 1 R | 16 | 160" className="text-[#002726]" data-sentry-element="Typography" data-sentry-source-file="SectionNSDC.tsx">{`The National Skill Development Corporation (NSDC), under the Government of India, promotes skill development. Your course is a part of NSDC programme and you’ll receive a certificate upon completion*`}</Typography>
          <Typography variant="Body 1 M | 16 | 120" className={`text-[#002726] font-medium leading-[19.2px] ${!isMobile ? "mt-[24px]" : "mt-[48px]"}`} data-sentry-element="Typography" data-sentry-source-file="SectionNSDC.tsx">{`Benefits of NSDC Certification:`}</Typography>
          <div className="flex flex-col gap-[6px] mt-[12px]">
            <Typography variant="Body 1 R | 16 | 160" className="text-[#002726]" data-sentry-element="Typography" data-sentry-source-file="SectionNSDC.tsx">{`1. Boost your career prospects with a certification acknowledged across India.`}</Typography>
            <Typography variant="Body 1 R | 16 | 160" className="text-[#002726]" data-sentry-element="Typography" data-sentry-source-file="SectionNSDC.tsx">{`2. Improves chances of employment and career advancement.`}</Typography>
            <Typography variant="Body 1 R | 16 | 160" className="text-[#002726]" data-sentry-element="Typography" data-sentry-source-file="SectionNSDC.tsx">{`3. Ensures top-quality education and training.`}</Typography>
          </div>
          <Typography variant="Body 1 R | 16 | 160" className="text-[#002726] mt-[24px]" data-sentry-element="Typography" data-sentry-source-file="SectionNSDC.tsx">{`Register for NSDC certification today and advance your career with industry-recognized credentials.`}</Typography>
          <Typography variant="Body 1 R | 16 | 160" className="mt-[10px] text-[#686C7A]" data-sentry-element="Typography" data-sentry-source-file="SectionNSDC.tsx">{`* Subject to evaluation and attendance`}</Typography>
          {isMobile && <MoreDetails isMobile={isMobile} />}
        </div>
        {!isMobile && <>
            <CertImage isMobile={isMobile} />
            <MoreDetails isMobile={isMobile} />
          </>}

        {isMobile && <button onClick={() => setViewAll(!viewAll)} className={`read-more-link ${viewAll ? "read-more-link-open" : ""} justify-self-center pt-[32px]`}>
            {viewAll ? "Show Less" : "Read More"}
            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="15" viewBox="0 0 10 15" fill="none">
              <path d="M9 7.1875L5 11.1875L1 7.1875" stroke="#002726" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>}
      </div>
    </SectionSkinBackground>;
};
export default SectionNSDC;
const MoreDetails = ({
  isMobile
}: {
  isMobile: boolean;
}) => {
  return <Typography variant="Body 1 R | 16 | 160" className={`text-[#002726] ${isMobile ? "mt-[24px]" : "mt-[6px]"}`} data-sentry-element="Typography" data-sentry-component="MoreDetails" data-sentry-source-file="SectionNSDC.tsx">
      For more details, visit: {" "}
      <a href="https://nsdcindia.org/" target="_blank" className="text-[#002726]">NSDC</a>
    </Typography>;
};
const CertImage = ({
  isMobile
}: {
  isMobile: boolean;
}) => {
  return <Image className={`${!isMobile ? "mt-[32px]" : "mb-[24px]"}`} src="/images/course-diff/nsdc-cert.png" alt="nsdc certificate" width={631} height={431} loading="lazy" data-sentry-element="Image" data-sentry-component="CertImage" data-sentry-source-file="SectionNSDC.tsx" />;
};